export type AlternativesNavigationTarget = {
  path: string
  query: Record<string, string | undefined>
}

const ALTERNATIVES_FALLBACK: AlternativesNavigationTarget = { path: '/search', query: {} }

export const useAlternativesUrl = () => {
  const { locale } = useI18n()
  const { searchLanguage } = useCountryConfig()
  const treeStore = useCategoryTreeStore()

  const alternativesUrl = (target: AlternativesNavigationTarget | null | undefined): AlternativesNavigationTarget =>
    target ?? ALTERNATIVES_FALLBACK

  function categoryPagePath(categoriesNew: string[] | undefined): string | null {
    if (!categoriesNew?.length || treeStore.tree.length === 0) return null
    const resolved = treeStore.resolveDeepestPath(categoriesNew, searchLanguage)
    if (!resolved) return null
    const slugs = [...resolved.ancestors, resolved.node]
      .map(n => treeStore.normalize(n.terms[locale.value] ?? ''))
    return `/c/${slugs.join('/')}`
  }

  return {
    alternativesUrl,
    categoryPagePath,
  }
}
